export const getParams = name => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
};
export const sdk = (name, data) => {
  if (getParams('devicePlate') == 'android') {
    try {
      if (
        window.sdkCtrl &&
        Object.prototype.toString.call(
          window.sdkCtrl.callSDKMethodWithParameters
        ) === '[object Function]'
      ) {
        window.sdkCtrl.callSDKMethodWithParameters(name, JSON.stringify(data));
      }
    } catch (error) {}
  } else {
    try {
      window.webkit.messageHandlers.callSDKMethodWithParameters.postMessage({
        method: name,
        params: data,
      });
    } catch (error) {}
  }
};
export const isGameSdk =
  getParams('sdkToken') && getParams('packageName') && getParams('devicePlate');

export const sleep = time => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, 1000 * +time);
  });
};
export const isFBAndroid =
  /FB/.test(navigator.userAgent) && /Android/.test(navigator.userAgent);
